<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{modalTitle}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  @if (errorMessage) {
    <div class="alert alert-danger">{{ errorMessage }}</div>
  }
  <form #userForm="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">Name</label>
            <input type="text" class="form-control" name="name" [pattern]="pattern.Name"
              #personName="ngModel" [(ngModel)]="newUser.name" required>
          </div>
          @if (personName.touched && personName.invalid) {
            <div class="text-danger">
              {{ personName.errors?.['pattern'] ? "Name should not contains numbers or special characters" :
              "Please enter the name" }}
            </div>
          }
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">Email Id</label>
            <input type="text" [disabled]="newUser._id" #email="ngModel" class="form-control" name="emailId"
              [(ngModel)]="newUser.email" [pattern]="pattern.email" required>
          </div>
          @if (email.touched && email.invalid) {
            <div class="text-danger">
              {{ email.errors?.['pattern'] ? "Please enter a valid email format" : "Please enter your
              email address." }}
            </div>
          }
        </div>
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Mobile No</label>
            <input type="number" #mobile="ngModel" class="form-control" name="mobileNo"
              [(ngModel)]="newUser.mobile" [pattern]="pattern.mobile" OnlyNumber="true" required>
          </div>
          @if (mobile.touched && mobile.invalid) {
            <div class="text-danger">
              {{ mobile.errors?.['pattern'] ? "Mobile number must be 10 digits" : "Please enter your
              mobile number." }}
            </div>
          }
        </div>
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Department</label>
            <select class="form-control form-select" name="department" #department="ngModel" [(ngModel)]="newUser.department" (change)="onDepartmentChange()" required>
              @for (d of depts; track d) {
                <option [value]="d.dept">{{d.dept}}</option>
              }
            </select>
          </div>
          @if (department.touched && department.invalid) {
            <div class="text-danger">
              Please select department
            </div>
          }
        </div>
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Role</label>
            <select class="form-control form-select" name="role" #role="ngModel" [(ngModel)]="newUser.role" required>
              @for (r of roles; track r) {
                <option [value]="r">{{r}}</option>
              }
            </select>
          </div>
          @if (role.touched && role.invalid) {
            <div class="text-danger">
              Please select a role
            </div>
          }
        </div>
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Status</label>
            <select class="form-control form-select" #status="ngModel" name="status"
              [(ngModel)]="newUser.status" required>
              <option value="Active">Active</option>
              <option value="In-Active">In-Active</option>
            </select>
          </div>
          @if (status.touched && status.invalid) {
            <div class="text-danger">
              Please select status
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-4 text-center">
          <button [disabled]="!userForm.valid" class="btn btn-primary active mt-4 w-50"
          (click)="onSubmit()">Submit</button>
        </div>
      </div>
    </div>
  </form>
</div>